import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './BlogPage.css';

// 상세 본문은 BlogPostPage가 관리한다. 목록에는 렌더링·SEO에 필요한 메타데이터만 둔다.
const BLOG_POSTS = [
  {
    id: 11,
    title: '2026 AI 학습지 자동 생성 | 객관식·서술형·빈칸채우기 3분 완성',
    excerpt: '학습지 만드는 데 4시간? AI가 3분이면 만들어드려요. 객관식, 서술형, 빈칸 채우기, 수행평가 루브릭까지 인쇄해서 바로 사용 가능한 학습지 생성 방법을 공개합니다.',
    author: '왓퀴즈 에디터',
    date: '2026-03-06',
    category: '신기능 안내',
    readTime: '8분',
    featured: true,
  },
  {
    id: 10,
    title: '2026 교사를 위한 AI 이미지 생성 | 수업 자료 이미지 만들기',
    excerpt: '교육용 다이어그램, 색칠 도안, PPT 삽화, 학급 포스터까지. AI가 수업 자료에 딱 맞는 이미지를 만들어드려요. 무료로 바로 시작하세요.',
    author: '왓퀴즈 에디터',
    date: '2026-03-06',
    category: '신기능 안내',
    readTime: '7분',
    featured: true,
  },
  {
    id: 9,
    title: '2026 수업 PPT 자동 생성 | AI가 디자인까지 10분 완성',
    excerpt: '수업 PPT 만드는 데 2시간? AI가 10분이면 이미지 포함 고품질 PPT를 만들어드려요. 주제만 말하면 슬라이드 구성부터 디자인까지 자동 완성.',
    author: '왓퀴즈 에디터',
    date: '2026-03-06',
    category: '신기능 안내',
    readTime: '8분',
    featured: true,
  },
  {
    id: 8,
    title: '2025년 교사를 위한 AI 도구 완전 정복: 각 모델별 숨겨진 장점과 실전 활용법',
    excerpt: '교사들이 모르는 AI 도구들의 진짜 장점과 교육 현장에서만 통하는 실전 활용법을 공개합니다. ChatGPT만 써봤다면 놓치고 있는 강력한 도구들을 발견해보세요.',
    author: '왓퀴즈 에디터',
    date: '2025-06-23',
    category: '실전 노하우',
    readTime: '18분',
    featured: true,
  },
  {
    id: 7,
    title: '2027 교사를 위한 AI 도구 TOP 5 - 수업 준비부터 평가·생기부까지 쓰임새별 정리',
    excerpt: '2027학년도 2022 개정 교육과정 전 학년 적용과 2026 생기부 기재요령에 맞춰, 교사가 많이 쓰는 AI 도구 다섯 가지를 쓰임새와 주의할 점 중심으로 정리했어요.',
    author: '왓퀴즈 에디터',
    date: '2026-11-05',
    category: '실전 노하우',
    readTime: '8분',
    featured: true,
  },
  {
    id: 'digital-literacy-classroom',
    title: '교실에서 시작하는 디지털 리터러시 교육',
    excerpt: '학생들의 디지털 역량 향상을 위한 체계적인 접근 방법과 실습 예제를 제공합니다. 연령별 맞춤 교육 전략을 다룹니다.',
    author: '디지털교육연구소',
    date: '2025-01-05',
    category: '교육법',
    readTime: '10분',
    featured: false,
  },
  {
    id: 1,
    title: '하루 30분으로 끝내는 수업 준비 시스템 - 15년 경력 교사가 공개하는 시간 절약 비밀 노하우',
    excerpt: '매일 밤늦게까지 수업 준비하느라 지치셨나요? 전국 3,000명의 교사가 검증한 실전 시간 단축 방법들을 통해 수업 준비 시간을 1/3로 줄이면서도 수업 퀄리티는 오히려 높일 수 있습니다.',
    author: '왓퀴즈 에디터',
    date: '2025-01-27',
    category: '실전 노하우',
    readTime: '12분',
    featured: true,
  },
  {
    id: 2,
    title: 'Z세대 학생들이 실제로 집중하는 수업 방식 10가지 - 현직 교사 3년 연구 결과',
    excerpt: '스마트폰 세대 학생들의 주의를 끌고 몰입하게 만드는 검증된 수업 기법들을 공개합니다. 디지털 네이티브 세대의 특성을 이해하고 활용하는 실전 노하우를 담았습니다.',
    author: '왓퀴즈 에디터',
    date: '2025-01-25',
    category: '실전 노하우',
    readTime: '10분',
    featured: false,
  },
  {
    id: 3,
    title: '문제 학생 상담, 이렇게 하면 90% 성공한다 - 상담 전문가가 알려주는 비밀',
    excerpt: '어려운 학생과의 상담이 두렵지 않게 만드는 구체적인 대화 기법과 상황별 대응 방법을 제시합니다. 실제 상담 사례와 성공 스토리를 통해 검증된 방법들을 공유합니다.',
    author: '왓퀴즈 에디터',
    date: '2025-01-23',
    category: '학생 지도',
    readTime: '9분',
    featured: false,
  },
  {
    id: 4,
    title: '학부모 민원 대응 시나리오별 대화법 - 실제 사례 7가지',
    excerpt: '까다로운 학부모 민원을 현명하게 해결하는 구체적인 대화 스크립트와 대응 전략을 제공합니다. 갈등을 협력으로 바꾸는 커뮤니케이션 노하우를 담았습니다.',
    author: '왓퀴즈 에디터',
    date: '2025-01-21',
    category: '학급 경영',
    readTime: '11분',
    featured: false,
  },
  {
    id: 5,
    title: '교사 번아웃에서 벗어나는 5가지 실전 방법 - 정신건강 전문가 조언',
    excerpt: '교직에 대한 열정을 되찾고 건강한 교사 생활을 지속하는 구체적인 방법들을 제시합니다. 번아웃 예방부터 회복까지, 실제로 효과가 있는 전략들을 소개합니다.',
    author: '왓퀴즈 에디터',
    date: '2025-01-19',
    category: '교사 웰빙',
    readTime: '8분',
    featured: false,
  },
  {
    id: 6,
    title: 'AI 시대, 교사만이 할 수 있는 것들 - 미래 교육의 핵심 가치',
    excerpt: '인공지능이 발달해도 대체될 수 없는 교사의 고유 영역과 역할을 탐구합니다. 미래 교육에서 교사가 가져야 할 핵심 역량과 가치를 제시합니다.',
    author: '왓퀴즈 에디터',
    date: '2025-01-17',
    category: '미래 교육',
    readTime: '7분',
    featured: false,
  },
];

const formatPostDate = (dateString) => {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return dateString;

  return date.toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

const BlogPage = () => {
  const featuredPosts = BLOG_POSTS.filter((post) => post.featured);

  return (
    <div className="blogpage-page">
      <Helmet>
        <title>교사 블로그 | AI PPT · 학습지 · 이미지 · 생기부 활용 가이드 | 왓퀴즈</title>
        <meta
          name="description"
          content="교사를 위한 AI 활용 가이드. AI PPT 만들기, 학습지 자동 생성, 이미지 생성, 생기부 작성, 수행평가 채점 등 실전 팁. 현직 교사들의 경험과 노하우를 공유합니다."
        />
        <meta
          name="keywords"
          content="교사 블로그, AI PPT 만들기, 학습지 만들기, AI 이미지 생성, 생기부 AI, 수행평가 채점, 교육 AI 가이드, 교사 전용 AI, 교사 업무 자동화, 왓퀴즈 블로그"
        />
        <link rel="canonical" href="https://whatquiz.co.kr/blog" />

        <meta
          property="og:title"
          content="교사 블로그 | AI PPT · 학습지 · 이미지 · 생기부 활용 가이드 | 왓퀴즈"
        />
        <meta
          property="og:description"
          content="AI PPT 만들기, 학습지 생성, 이미지 생성, 생기부 작성 등 교사를 위한 실전 AI 활용 가이드."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://whatquiz.co.kr/blog" />
        <meta property="og:image" content="https://whatquiz.co.kr/images/blog/blog-main.jpg" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="교사 블로그 | AI PPT · 학습지 · 이미지 활용 가이드 | 왓퀴즈"
        />
        <meta
          name="twitter:description"
          content="AI PPT 만들기, 학습지 생성, 이미지 생성, 생기부 작성 등 교사 AI 활용 팁을 공유합니다."
        />
        <meta name="twitter:image" content="https://whatquiz.co.kr/images/blog/blog-main.jpg" />

        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Blog',
            name: '왓퀴즈 교사용 블로그',
            description: 'AI PPT 만들기, 학습지 생성, 이미지 생성, 생기부 작성 등 교사를 위한 AI 활용 가이드와 실전 팁을 제공하는 교사 전용 블로그',
            url: 'https://whatquiz.co.kr/blog',
            publisher: {
              '@type': 'Organization',
              name: '플랙티컬 주식회사',
              url: 'https://whatquiz.co.kr',
            },
            blogPost: featuredPosts.map((post) => ({
              '@type': 'BlogPosting',
              headline: post.title,
              description: post.excerpt,
              url: `https://whatquiz.co.kr/blog/${post.id}`,
              datePublished: post.date,
              author: {
                '@type': 'Person',
                name: post.author,
              },
            })),
          })}
        </script>
      </Helmet>

      <main className="blogpage-container">
        <header className="blogpage-hero">
          <p className="blogpage-eyebrow">교사 실전 가이드</p>
          <h1 className="blogpage-title">교사를 위한 AI 활용 가이드</h1>
          <p className="blogpage-description">
            수업 자료부터 생기부까지, 교육 현장에서 바로 적용할 수 있는
            AI 활용법과 교사 노하우를 정리했어요.
          </p>
        </header>

        <section aria-labelledby="blogpage-latest">
          <h2 id="blogpage-latest" className="blogpage-section-title">최신 글</h2>
          <div className="blogpage-grid">
            {BLOG_POSTS.map((post) => (
              <article key={post.id} className="blogpage-card">
                <Link to={`/blog/${post.id}`} className="blogpage-card-link">
                  <div className="blogpage-card-top">
                    <span className="blogpage-category">{post.category}</span>
                    {post.featured && <span className="blogpage-featured">추천</span>}
                  </div>

                  <h3 className="blogpage-card-title">{post.title}</h3>
                  <p className="blogpage-card-excerpt">{post.excerpt}</p>

                  <div className="blogpage-card-meta">
                    <span className="blogpage-card-author">
                      {post.author} · {post.readTime} 읽기
                    </span>
                    <time className="blogpage-card-date" dateTime={post.date}>
                      {formatPostDate(post.date)}
                    </time>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </section>

        <section className="blogpage-cta">
          <h2>읽은 내용을 바로 활용해보세요</h2>
          <p>왓퀴즈 AI와 대화하며 수업 자료와 문서를 바로 만들 수 있어요.</p>
          <div className="blogpage-cta-actions">
            <Link to="/chat" className="blogpage-cta-primary">AI 상담 시작하기</Link>
            <Link to="/help" className="blogpage-cta-secondary">고객센터</Link>
          </div>
        </section>
      </main>
    </div>
  );
};

export default BlogPage;
